import Vue from "vue";
const vm = new Vue();

export const getShipmentPending = async (search) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + "/failreport/shipment", {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                date_start: search.date.startDate,
                date_end: search.date.endDate,
                courier_tracking_code: search.courierTrackingCode,
                category_id: search.categoryId,
                sender: search.sender,
                dest: search.dest
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};


export const getShipmentPendingCategory = async () => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + "/failreport/category", {
            headers: {
                Token: localStorage.getItem("access_token")
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const getCountShipmentPending = async () => {
    return new Promise((resolve, reject) => {
      vm.$http
        .get( vm.$API_URL + "/failreport/count/shipment", {
            headers: {
                Token: localStorage.getItem("access_token")
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const updateVisibleShipmentPending = async (shipment_id , visible) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/failreport/update/visible`, 
            {
                shipment_id: shipment_id,
                visible: visible
            },
            {
                headers: { Token: localStorage.getItem("access_token") }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const updateFeedbackShipmentPending = async (shipment) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/failreport/update/feedback`, 
            {
                shipment: shipment
            },
            {
                headers: { Token: localStorage.getItem("access_token") }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const updateRemarkShipmentPending = async (shipment_id , remark) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/failreport/update/remark/${shipment_id}`, 
            {
                remark: remark
            },
            {
                headers: { Token: localStorage.getItem("access_token") }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const updateStatusCourierShipmentPending = async (shipment_id , status) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .put( vm.$API_URL + `/failreport/status/courier`, 
            {
                shipment_id: shipment_id,
                status: status
            },
            {
                headers: { Token: localStorage.getItem("access_token") }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};